
//******************Exchange Rate Server Calls******************;

import {ScheduledWeekListActions} from './ScheduledWeekListConstants';
import store from '../../../Store/store'
import {ROOT_URL,getCookie} from '../../../Config/Config';
import {failure_messages} from "Messages"


export const ScheduledWeekListServer = {
  //  getScheduledWeekList:getScheduledWeekList,
  getScheduledWeekList:getScheduledWeekList,
  //  updateScheduledWeekList:updateScheduledWeekList
};

//******************Insert ScheduledWeekLists******************;

function getScheduledWeekList(data){
      const request=fetch(ROOT_URL+'/api/banner/getScheduledWeeks', {
          method: 'Post',
          mode: 'cors',
          headers: { 
            'authorization':getCookie("admin_token_partner"),
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
          }).then((response)=>{
           response.json().then(response=>{
             if(response.status == "200"){
             // alert(JSON.stringify(response))
            store.dispatch({type:ScheduledWeekListActions.ScheduledWeekList_GET.SUCCESS,payload:response.data});
            return ;
            }else
            {
              store.dispatch({type:ScheduledWeekListActions.ScheduledWeekList_GET.FAILED, error:response.error});
              return ;
              }    
           });
          }).catch((error) => {
          //  alert(error)
           store.dispatch({type:ScheduledWeekListActions.ScheduledWeekList_GET.FAILED, error:failure_messages.ScheduledWeeksError});
            })
      return {type:ScheduledWeekListActions.ScheduledWeekList_GET.LOADING}

};
  
//******************Get ScheduledWeekLists******************;


//******************Update ScheduledWeekList******************;

  
// function getScheduledWeekList(){
//       const request=fetch(ROOT_URL+'/api/exchangeRate/getExchangeRate/', {
//           method: 'GET',
//           mode: 'cors',
//           headers: {'Content-Type':'application/json'},
//          // body: JSON.stringify(data)
//           }).then((response)=>{
//             response.json().then(response=>{
//               if(response.status == "200"){
//                 console.log(response)
//                 if(response.ScheduledWeekList.length>0)
//              store.dispatch({type:ScheduledWeekListActions.ScheduledWeekList_Get.SUCCESS,payload:response.ScheduledWeekList});
//              else
//              store.dispatch({type:ScheduledWeekListActions.ScheduledWeekList_GET.NEW});
             
//              return ;
//              }else
//              {
//                store.dispatch({type:ScheduledWeekListActions.ScheduledWeekList_Get.FAILED});
//                return ;
//                }    
//             });
//            }).catch((error) => {
//             store.dispatch({type:ScheduledWeekListActions.ScheduledWeekList_Get.FAILED});
//           })
//        return {type:ScheduledWeekListActions.ScheduledWeekList_GET.LOADING}
 
//     };
  
// function updateScheduledWeekList(data){
//   const request=fetch(ROOT_URL+'/api/exchangeRate/BulkUpdateExchangeRate', {
//     method: 'Post',
//     mode: 'cors',
//     headers: {'Content-Type':'application/json'},
//     body: JSON.stringify(data)
//     }).then((response)=>{
//      response.json().then(response=>{
//        if(response.status == "200"){
//          console.log(response)
//       store.dispatch({type:ScheduledWeekListActions.ScheduledWeekList_GET.SUCCESS});
//       return ;
//       }else
//       {
//         store.dispatch({type:ScheduledWeekListActions.ScheduledWeekList_GET.FAILED});
//         return ;
//         }    
//      });
//     }).catch((error) => {
//       store.dispatch({type:ScheduledWeekListActions.ScheduledWeekList_GET.FAILED});
//     })
// return {type:ScheduledWeekListActions.ScheduledWeekList_GET.LOADING}

// };
